export function isVrbo(context) {
  var _a;
  return ((_a = context === null || context === void 0 ? void 0 : context.site) === null || _a === void 0 ? void 0 : _a.brand) === 'vrbo';
}
export function isHcom(context) {
  var _a;
  return ((_a = context === null || context === void 0 ? void 0 : context.site) === null || _a === void 0 ? void 0 : _a.brand) === 'hotels';
}